export default __webpack_public_path__ + "static/media/nutrionist.abb2f547.png";